      <div class="reel reveal" data-reel{{{ root }}}>
{{#each items}}

        <article class="reel-panel" data-panel{{{ edit }}}>
          <button class="reel-hit" type="button" aria-expanded="false" aria-controls="reel-{{ @n }}">
            <span class="visually-hidden"{{{ hidden.attrs }}}>{{{ hidden.html }}}</span>
          </button>
          <p class="reel-no">00—{{ @n }}</p>

          <img class="reel-still" src="{{ poster }}"
               alt="" aria-hidden="true" loading="lazy" decoding="async"
               style="--fx: {{ fx }}; --fy: {{ fy }}">

          <div class="reel-open" id="reel-{{ @n }}">
            <p class="reel-spec"{{{ spec.attrs }}}>{{{ spec.html }}}</p>
            <div class="reel-stage">
              <video data-reel-video poster="{{ poster }}"
                     preload="none" playsinline muted loop
                     aria-label="{{{ label }}}">
                <source src="{{ video }}" type="video/mp4">
              </video>
              <span class="reel-play" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M9 6.5v11l9-5.5z"/></svg></span>
              <span class="reel-time">{{ time }}</span>
            </div>
            <p class="reel-note"{{{ note.attrs }}}>{{{ note.html }}}</p>
          </div>

          <h3 class="reel-title"{{{ title.attrs }}}>{{{ title.html }}}</h3>
        </article>
{{/each}}

      </div>
